import TumengBlock from './src/index.vue'

TumengBlock.install = function(Vue) {
  Vue.component(TumengBlock.name, TumengBlock)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengBlock)
}

export default TumengBlock
